/**
 * 半角数字またはハイフンのみで構成された文字列かどうかを判定する
 *
 * バックエンド側でも厳密なバリデーションを実施していないため、電話番号として正しい形式かまでチェックしない
 *
 * @param value string
 * @returns boolean
 */
export const validateHalfWidthPhoneNumber = (value: string) =>
  /^[0-9-]*$/.test(value);
